import { schema } from 'normalizr';

export const UserSchema = new schema.Entity('users');
export const UserListSchema = [UserSchema];

export const QuestTopicSchema = new schema.Entity('questTopics');
export const QuestTopicListSchema = [QuestTopicSchema];

export const SkillLevelQuestionnaireAnswerSchema = new schema.Entity(
  'skillLevelQuestionnaireAnswers',
);
export const SkillLevelQuestionnaireAnswerListSchema = [
  SkillLevelQuestionnaireAnswerSchema,
];

export const TagSchema = new schema.Entity('tags');
export const TagsListSchema = [TagSchema];

export const TutorialSchema = new schema.Entity('tutorials', {
  tags: TagsListSchema,
});
export const TutorialListSchema = [TutorialSchema];

export const TutorialTagSchema = new schema.Entity('tutorialTags');
export const TutorialTagsListSchema = [TutorialTagSchema];

export const TrackSchema = new schema.Entity('tracks', {
  user: UserSchema,
});
export const TrackListSchema = [TrackSchema];

export const NotificationSchema = new schema.Entity('notifications');
export const NotificationListSchema = [NotificationSchema];

export const PaymentMethodSchema = new schema.Entity(
  'paymentMethods',
);
export const PaymentMethodListSchema = [PaymentMethodSchema];

export const ConversationSchema = new schema.Entity('conversations', {
  user: UserSchema,
});
export const ConversationListSchema = [ConversationSchema];

export const MessageSchema = new schema.Entity('messages');
export const MessageListSchema = [MessageSchema];

export const PostSchema = new schema.Entity('posts', {
  user: UserSchema,
});
export const PostListSchema = [PostSchema];

export const CommentSchema = new schema.Entity('comments', {
  user: UserSchema,
});
export const CommentListSchema = [CommentSchema];

export const CourseSchema = new schema.Entity('courses');
export const CourseListSchema = [CourseSchema];

export const LessonSchema = new schema.Entity('lessons', {
  videos: [TutorialSchema],
});
export const LessonListSchema = [LessonSchema];

export const SectionSchema = new schema.Object({
  videos: TutorialListSchema,
  courses: CourseListSchema,
});

export const SectionListSchema = [SectionSchema];
